export const getStyles = ({ isFeaturedCompany }) => ({
	featuredCompanyHeader: {
		wrapper:
			"tw:py-2 tw:px-2 tw:flex tw:justify-center tw:bg-[#0B60E0] tw:text-white tw:rounded-t-[12px] tw:sm:py-3 tw:md:py-3.5",
		contentWrapper:
			"tw:text-center tw:text-sm tw:font-bold tw:leading-6 tw:tracking-[-0.2px] tw:sm:leading-[28px] tw:sm:text-lg tw:md:text-xl",
	},
	coupon: {
		wrapper: "tw:group tw:p-2 tw:cursor-pointer",
		contentWrapper:
			"tw:flex tw:bg-[#E0F6FF] tw:rounded-lg tw:w-full tw:p-2 tw:justify-center tw:items-center",
		contentIcon: "tw:inline-flex tw:mr-2 tw:text-2xl tw:text-[#03398A]",
		content:
			"tw:text-pretty tw:text-center tw:text-sm tw:font-medium tw:leading-4 tw:text-[#03398A] tw:tracking-[-0.16px] tw:group-hover:underline tw:md:text-base tw:sm:leading-6",
	},
	serviceFlag: {
		wrapper: "",
		flag: `tw:absolute tw:top-20 tw:-translate-y-2/4 tw:-left-4 tw:w-8 tw:h-8 tw:flex tw:items-center tw:justify-center tw:rounded-full tw:border-2 tw:border-current tw:bg-white tw:md:top-2/4 ${
			isFeaturedCompany ? "tw:text-[#0B60E0]" : "tw:text-[#03398A]"
		}`,
		number: "tw:text-current tw:text-base tw:font-medium tw:leading-6",
		text: "tw:absolute tw:top-4 tw:left-0 tw:text-white tw:text-xs tw:bg-[#0B60E0] tw:font-medium tw:py-1 tw:pl-2 tw:pr-[16px] tw:leading-4 tw:[clip-path:polygon(100%_0,calc(100%-10px)_50%,100%_100%,0_100%,0_0)] tw:md:top-6",
	},
	companyLogo: { picture: "", image: "" },
	rating: {
		wrapper:
			"tw:mt-2 tw:w-fit tw:inline-flex tw:items-center tw:gap-1.5 tw:rounded-full tw:bg-white tw:p-3 tw:shadow-[0px_2px_4px_0px_rgba(30,41,59,0.08),0px_0px_1px_0px_rgba(30,41,59,0.16)] tw:md:py-2 tw:lg:py-3 tw:lg:px-4",
		score:
			"tw:text-[28px] tw:font-medium tw:leading-8 tw:tracking-[-1.12px] tw:text-[#1E293B]",
		stars: "tw:flex tw:flex-col tw:gap-1",
		starColor: "tw:text-[#FFA100]",
		starSize: "tw:text-base",
		count: "tw:ml-px tw:text-xs tw:font-medium tw:leading-3 tw:text-[#475569]",
	},
	benefitsList: {
		wrapper: "tw:mt-4",
		list: "tw:flex tw:flex-col tw:gap-2 tw:justify-center",
		listItem:
			"tw:flex tw:text-[#1E293B] tw:text-sm tw:leading-5 tw:gap-2 tw:sm:text-base tw:sm:leading-6 tw:text-pretty",
	},
	socialProof: {
		wrapper:
			"tw:relative tw:flex tw:mb-3.5 tw:rounded-lg tw:max-w-fit tw:bg-white tw:p-2 tw:filter-[drop-shadow(0px_0px_1px_rgba(88,102,126,0.48))_drop-shadow(0px_0px_24px_rgba(88,102,126,0.10))] tw:after:absolute tw:after:right-[calc(50%-6px)] tw:after:w-2.5 tw:after:h-2.5 tw:after:translate-x-0 tw:after:-translate-y-2/4 tw:after:rotate-45 tw:after:bg-white tw:after:overflow-hidden tw:after:pointer-events-none tw:after:top-full",
		contentWrapper:
			"tw:flex tw:flex-row tw:justify-center tw:items-center tw:gap-2",
		contentIcon: "tw:text-[#232529] tw:text-[32px]",
		content:
			"tw:min-w-[102px] tw:max-w-[106px] tw:leading-4 tw:font-medium tw:text-xs tw:text-left tw:text-[#1E293B]",
	},
	visitLink: {
		wrapper:
			"tw:inline-flex tw:w-full tw:group tw:justify-center tw:p-2 tw:bg-[#0B60E0] tw:rounded-full tw:transition tw:duration-300 tw:gap-1.5 tw:cursor-pointer tw:hover:bg-[#144794] tw:md:py-3",
		contentWrapper:
			"tw:text-white tw:font-medium tw:leading-6 tw:text-base tw:md:text-lg",
		iconClass:
			"tw:hidden tw:text-2xl tw:text-white tw:transition-all tw:duration-300 tw:group-hover:translate-x-1 tw:lg:inline-flex",
	},
});
